import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'humanizeNumber' })
export class HumanizeNumberPipe implements PipeTransform {
  transform(value: any, decimals: number = 1): string {
    if (value === null || value === undefined) return 'n/a';

    // only format if it's a number
    if (typeof value !== 'number') {
      return value;
    }

    const sign = value < 0 ? '-' : '';
    const abs = Math.abs(value);

    const units = [
      { v: 1_000_000_000_000, s: 'T' },
      { v: 1_000_000_000, s: 'B' },
      { v: 1_000_000, s: 'M' },
      { v: 1_000, s: 'K' },
    ];

    for (const u of units) {
      if (abs >= u.v) {
        return sign + this.trim((abs / u.v).toFixed(decimals)) + u.s;
      }
    }
    return sign + abs.toString();
  }

  private trim(n: string): string {
    return n.replace(/\.0+$/, '').replace(/(\.\d*[1-9])0+$/, '$1');
  }
}
